import styled from "styled-components";
import logo from "./logo.svg";
import { DesignTokens } from "../../common-ui/styles/design-tokens";

const { fonts, spacings } = DesignTokens;

const Wrapper = styled.div`
  position: absolute;
  top: ${spacings.xlarge}px;
  left: ${spacings.xlarge}px;
`;

const StyledLogo = styled.img`
  height: 25px;
`;

const StyledApplicationName = styled.div`
  font-family: ${fonts.sansSerifMd};
`;

export const FloatingLogo: React.FC = () => {
  return (
    <Wrapper>
      <StyledLogo src={logo} />
      <StyledApplicationName>Fusion</StyledApplicationName>
    </Wrapper>
  );
};
